<template>
    <div class="element" :data-required="this.required" :class="{ [this.type] : true, error : error.error, success: !error.error && error.init }">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <placeholderElement v-bind="resolveProps('placeholder', this)" :error="error" :value="this.input" />
        <stateElement v-bind="resolveProps('state', this)" :error="error" />
        <input
            type="text"
            class="input"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="!this.editing || this.readonly"
            :placeholder="`${this.show_placeholder ? placeholder + (required ? ' *' : '') : ''}`"
            :autocomplete="this.autocomplete"
            :maxlength="this.maxlength"
            :aria-describedby="error.error ? `error_${this.id}` : null"
            v-model="input"
            @keyup="validate"
            @blur="validate"
            @change="handleChange"
        />
        <errorElement v-bind="resolveProps('error', this)" :error="error" :errorId="`error_${this.id}`" />
        <tooltipElement v-bind="resolveProps('tooltip', this)" :inline="true" />
    </div>
</template>

<script>
import {defineComponent, ref, watch, inject, onMounted, computed } from "vue";

// Our form helpers
import useFieldValidation from "formbuilder/fields/_validation";
import { validateVAT } from "helpers/_validate";

import { propDefaults, resolveProps } from "formbuilder/fields/_props";

import labelElement from "formbuilder/elements/LabelElement.vue";
import stateElement from "formbuilder/elements/StateElement.vue";
import placeholderElement from "formbuilder/elements/PlaceholderElement.vue";
import errorElement from "formbuilder/elements/ErrorElement.vue";
import tooltipElement from "formbuilder/elements/TooltipElement.vue";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

export default defineComponent({
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        labelElement,
        stateElement,
        placeholderElement,
        errorElement,
        tooltipElement
    },
    setup(props, { emit }) {
        const input = ref("");
        const {registerValidator, validate, error} = useFieldValidation();
        registerValidator(input, props);

        watch(
            () => props.value,
            () => {
                input.value = props.value;
            },
            {
                immediate: true
            }
        );

        // inject componentData
        const componentData = inject("componentData");

        const handleChange = () => {
            let countryCode = componentData.countryCode || "NL";

            const result = validateVATInternational(input.value, countryCode);
            if (!result.valid) {
                error.error = true;
                error.message = trans(result.error);
            } else {
                error.error = false;
                error.message = "";
            }
            emit('value-change', {
                name: props.name,
                value: input.value
            });
        }

        const placeholder = computed(() => props.translate ? trans(props.placeholder) : props.placeholder);

        watch(
            () => componentData.countryCode,
            () => {
                handleChange();
            },
            {
                immediate: false
            }
        );

        return {
            trans,
            input,
            error,
            resolveProps,
            validate,
            handleChange,
            placeholder
        };
    },
});
</script>